import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#005596', // Sound Transit blue (approximate)
      light: '#3377ab',
      dark: '#003b69',
      contrastText: '#fff',
    },
    secondary: {
      main: '#6ab023', // Sound Transit green (approximate)
      light: '#87bf4f',
      dark: '#4a7b18',
      contrastText: '#fff',
    },
    background: {
      default: '#f4f7f9',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 500,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
    },
    h6: {
      fontSize: '1.25rem',
      fontWeight: 500,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

export default theme;
